import script from "./SummaryCards.vue?vue&type=script&lang=ts&setup=true"
export * from "./SummaryCards.vue?vue&type=script&lang=ts&setup=true"

import "./SummaryCards.vue?vue&type=style&index=0&id=283c6767&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-283c6767"]])

export default __exports__